import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import BlogPage from './pages/BlogPage';
import BlogPost from './pages/BlogPost';
import UseCasesIndex from './pages/UseCasesIndex';
import SeoPage from './pages/SeoPage';
import KeywordPage from './pages/KeywordPage';
import PartnerPage from './pages/PartnerPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AdminDashboard from './AdminDashboard';
import NotFound from './components/NotFound';
import { Toaster } from 'sonner';

function App() {
  return (
    <Router>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/use-cases" element={<UseCasesIndex />} />
        <Route path="/use-cases/:slug" element={<SeoPage />} />
        <Route path="/telegram-email-bot" element={<KeywordPage slug="telegram-email-bot" />} />
        <Route path="/receive-email-on-telegram" element={<KeywordPage slug="receive-email-on-telegram" />} />
        <Route path="/telegram-email-integration" element={<KeywordPage slug="telegram-email-integration" />} />
        <Route path="/temporary-email-telegram" element={<KeywordPage slug="temporary-email-telegram" />} />
        <Route path="/email-to-telegram-alerts" element={<KeywordPage slug="email-to-telegram-alerts" />} />
        <Route path="/create-email-bot-telegram" element={<KeywordPage slug="create-email-bot-telegram" />} />
        <Route path="/etlgr-bot-alternative" element={<KeywordPage slug="etlgr-bot-alternative" />} />
        <Route path="/gmail-in-telegram" element={<KeywordPage slug="gmail-in-telegram" />} />
        <Route path="/staymii-hr-job-application-form" element={<PartnerPage slug="staymii-hr-job-application-form" />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
